import { render } from "./ObjetosProhibidos.vue?vue&type=template&id=ad6fffda&scoped=true"
import script from "./ObjetosProhibidos.vue?vue&type=script&lang=js"
export * from "./ObjetosProhibidos.vue?vue&type=script&lang=js"

import "./ObjetosProhibidos.vue?vue&type=style&index=0&id=ad6fffda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6fffda"]])

export default __exports__